var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardHeader',[_c('ReportsDesigner',{attrs:{"tables":_vm.tables}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }